import React, { useState, useEffect } from "react";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import {
    appTransactionListAction,
  appTransferTokenAction,
} from "../../../../redux/admin/action";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import moment from "moment";
import dayjs from "dayjs";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { CircularProgress } from "@mui/material";

const AppTransactionList = () => {
  const { adminToken } = PagesIndex.useSelector((state) => state.AdminReducer);
  const navigate = PagesIndex.useNavigate();
  const [loading, setLoading] = useState(true);
  const [transactionList, setTransactionList] = useState([]);
  const [pageData, setPageData] = useState([]);
  const [search, setSearch] = useState("");
  const [filterData, setFilteredData] = useState([]);
  const [networkData, setNetworkData] = useState("All");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [btnLoading, setBtnLoading] = useState({});

  useEffect(() => {
    getTransactionHistory();
  }, []);

  const getTransactionHistory = async () => {
    try {
      const res = await appTransactionListAction(adminToken);
      if (res) {
        setTransactionList(res);
        setFilteredData(res); 
      }
    } catch (error) {
      console.error("Error fetching transactions", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    const filtered = transactionList.filter((item) => {
      const lowerSearch = search?.toLowerCase()?.trim();
      return (
        (!search ||
          item?.networkId?.networkName?.toLowerCase().includes(lowerSearch) ||
          item?.packageId?.packageName?.toLowerCase().includes(lowerSearch) ||
          item?.price?.toString().includes(lowerSearch) ||
          item?.walletAddress?.toLowerCase().includes(lowerSearch) ||
          item?.tokenTransferStatus?.toLowerCase().includes(lowerSearch) ||
          item?.transactionStatus?.toLowerCase().includes(lowerSearch) ||
          item?.userTransactionHash?.toLowerCase().includes(lowerSearch) ||
          item?.blockchainTransactionHash?.toLowerCase().includes(lowerSearch) ||
          item?.sapTokenTransferStatus?.toLowerCase().includes(lowerSearch) ||
          item?.maticTransactionHash?.toLowerCase().includes(lowerSearch) ||
          item?.sapTransactionHash?.toLowerCase().includes(lowerSearch) ||
          item?.maticTransactionHash?.toLowerCase().includes(lowerSearch) ||
          item?.productType?.toLowerCase().includes(lowerSearch) ||
          item?.maticTokenToSend?.toLowerCase().includes(lowerSearch) ||
          item?.sapTokenToSend?.toLowerCase().includes(lowerSearch) ||
          (item?.tokenValue?.toString().toLowerCase().includes(lowerSearch) ??
            false) ||
          (item?.platformFee?.toString().includes(lowerSearch) ?? false) ||
          new Date(item?.createdAt)
            .toLocaleDateString("en-GB")
            .includes(lowerSearch) ||
          (item?.transactionType === "buyWithCrypto"
            ? "Buy With Crypto"
            : "In App Purchase"
          )
            .toLowerCase()
            .includes(lowerSearch)) &&
        (networkData === "All" || item?.networkId?.networkName === networkData)
      );
    });

    setFilteredData(filtered);
  }, [transactionList, search, networkData]);

  const copyToClipboard = async (address) => {
    try {
      await navigator.clipboard.writeText(address);
      Index.toast.success("Copied successfully");
    } catch (err) {
      Index.toast.error("Could not copy address");
    }
  };

  const handleFilterUsers = () => {
    if (!fromDate || !toDate) return;

    const fromDateObj = new Date(fromDate);
    const toDateObj = new Date(toDate);
    toDateObj.setHours(23, 59, 59, 999);

    const filtered = transactionList.filter((item) => {
      const transactionDate = new Date(item?.createdAt);
      return transactionDate >= fromDateObj && transactionDate <= toDateObj;
    });
    setFilteredData(filtered);
  };

  const handleResetFilter = () => {
    setFromDate("");
    setToDate("");
    setSearch("");
    setNetworkData("All");
    setFilteredData(transactionList);
  };

  const handleTransferToken = async (id, index) => {
    setBtnLoading((prev) => ({ ...prev, [index]: true }));
    try {
      const res = await appTransferTokenAction(id, adminToken, navigate);
      console.log({ res });

      if (res?.status === 200) {
        getTransactionHistory();
        Index.toast.success(res?.message);
      } else {
        Index.toast.error(res?.message);
      }
    } catch (error) {
      Index.toast.error(error?.response?.data?.message);
      console.log(error);
    }
    setBtnLoading((prev) => ({ ...prev, [index]: false }));
  };

  return (
    <Index.Box className="page-content-box">
      <Index.Box className="episap-common-box">
        <Index.Box className="title-header">
          <Index.Box className="title-header-flex res-title-header-flex">
            <Index.Box className="title-main">
              <Index.Typography
                variant="p"
                component="p"
                className="page-title"
              >
               In App Purchase Transaction List
              </Index.Typography>
            </Index.Box>
              <Index.Box className="d-flex align-items-center res-set-search">
                <PagesIndex.Search className="searchbar">
                  <PagesIndex.StyledInputBase
                    placeholder="Search"
                    inputProps={{ "aria-label": "search" }}
                    onChange={handleSearch}
                    value={search}
                  />
                </PagesIndex.Search>
              </Index.Box>
          </Index.Box>
        </Index.Box>

        <Index.Box className="common-button blue-button">
          <Index.Grid container spacing={3} sx={{ marginBottom: "20px" }}>
            <Index.Grid item xs={12} sm={12} md={12} lg={4}>
              <Index.Box>
                <Index.Typography
                  variant="label"
                  component="label"
                  className="input-label"
                >
                  From Date
                </Index.Typography>
                <Index.Box className="input-design-div">
                  <Index.Box className="set-date set-date-picker picker-box-set">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DatePicker"]}>
                        <DemoItem label="">
                          <DatePicker
                            fullWidth
                            format="DD/MM/YYYY"
                            name="nomination_rec_date"
                            maxDate={dayjs(new Date())}
                            value={fromDate}
                            onChange={(value) => {
                              const formatedDate = moment(value.$d).format(
                                "YYYY/MM/DD"
                              );
                              setFromDate(formatedDate);
                            }}
                            slotProps={{
                              textField: {
                                readOnly: true,
                              },
                            }}
                          />
                        </DemoItem>
                      </DemoContainer>
                    </LocalizationProvider>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </Index.Grid>

            <Index.Grid item xs={12} sm={12} md={12} lg={4}>
              <Index.Box>
                <Index.Typography
                  variant="label"
                  component="label"
                  className="input-label"
                >
                  To Date
                </Index.Typography>
                <Index.Box className="input-design-div">
                  <Index.Box className="set-date set-date-picker picker-box-set">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DatePicker"]}>
                        <DemoItem label="">
                          <DatePicker
                            fullWidth
                            format="DD/MM/YYYY"
                            name="nomination_rec_date"
                            // maxDate={dayjs(new Date())}
                            value={toDate}
                            onChange={(value) => {
                              const formatedDate = moment(value.$d).format(
                                "YYYY/MM/DD"
                              );
                              setToDate(formatedDate);
                            }}
                            slotProps={{
                              textField: {
                                readOnly: true,
                              },
                            }}
                          />
                        </DemoItem>
                      </DemoContainer>
                    </LocalizationProvider>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </Index.Grid>

            <Index.Grid item xs={12} sm={12} md={12} lg={4}>
              <Index.Box className="referell-box">
                {fromDate && toDate ? (
                  <>
                    <Index.Box className="flex-filter-content">
                      <Index.Box className="common-button blue-button">
                        <Index.Button
                          variant="contained"
                          onClick={() => handleFilterUsers()}
                        >
                          Filter
                        </Index.Button>
                      </Index.Box>
                    </Index.Box>

                    <Index.Box className="flex-filter-content">
                      <Index.Box className="common-button blue-button">
                        <Index.Button
                          variant="contained"
                          onClick={() => handleResetFilter()}
                        >
                          Reset
                        </Index.Button>
                      </Index.Box>
                    </Index.Box>
                  </>
                ) : null}

                {/* <Index.Box className="flex-filter-content">
                    <Index.Box className="common-button blue-button">
                      <Index.Button
                        variant="contained"
                        onClick={() => {
                          let curDate = moment(new Date()).format("DD-MM-YYYY");
                          Export_excel(
                            exportReferralUsers,
                            `Referral Users (${curDate})`
                          );
                        }}
                      >
                        Export
                      </Index.Button>
                    </Index.Box>
                  </Index.Box> */}
              </Index.Box>
            </Index.Grid>
          </Index.Grid>
        </Index.Box>

        <Index.Box className="table-box table_scroll">
          <Index.TableContainer
            component={Index.Paper}
            className="episap-table-container"
          >
            <Index.Table
              stickyHeader
              aria-label="sticky table"
              className="episap-table-main"
            >
              <Index.TableHead>
                <Index.TableRow>
                  <Index.TableCell>No</Index.TableCell>
                  {/* <Index.TableCell>Currency Name</Index.TableCell> */}
                  <Index.TableCell >User Name</Index.TableCell>
                  <Index.TableCell>Package Name</Index.TableCell>
                  <Index.TableCell>Amount</Index.TableCell>
                  <Index.TableCell>SAP Token</Index.TableCell>
                  <Index.TableCell>Matic Token</Index.TableCell>
                  <Index.TableCell>Product Type</Index.TableCell>
                  <Index.TableCell>Receiver Address</Index.TableCell>
                  {/* <Index.TableCell>Receiver Address</Index.TableCell> */}
                  <Index.TableCell>SAP Transfer Hash</Index.TableCell>
                  <Index.TableCell>Matic Transaction Hash</Index.TableCell>
                  <Index.TableCell>SAP Token Transfer Status</Index.TableCell>
                  <Index.TableCell>Matic Token Transfer Status</Index.TableCell>
                  <Index.TableCell>Transaction Date & Time</Index.TableCell>
                  <Index.TableCell>Action</Index.TableCell>
                </Index.TableRow>
              </Index.TableHead>
              <Index.TableBody className="table-body">
                {!loading ? (
                  pageData?.length ? (
                    pageData?.map((row, index) => (
                      <Index.TableRow key={index}>
                        <Index.TableCell>{row.sNo}</Index.TableCell>
                        <Index.TableCell  style={{ textWrap:"nowrap" }}>
                          {row?.userId?.fullName || "-"}
                        </Index.TableCell>
                        <Index.TableCell>
                          {row?.packageId?.packageName || "-"}
                        </Index.TableCell>
                        <Index.TableCell>$ {row?.price?.toFixed(6)?.replace(/\.?0+$/, "")}</Index.TableCell>
                        <Index.TableCell>
                          {row?.sapTokenToSend}
                        </Index.TableCell>
                        <Index.TableCell>
                          {row?.maticTokenToSend}
                        </Index.TableCell>
                        <Index.TableCell>
                          {row?.productType||"-"}
                        </Index.TableCell>
                        <Index.TableCell>
                          <Index.Box className="wallet-address">
                            <Index.Tooltip
                              title={row?.walletAddress}
                              placement="top"
                            >
                              {row?.walletAddress
                                ? `${row?.walletAddress.substring(
                                    0,
                                    4
                                  )}.....${row?.walletAddress.substring(
                                    row?.walletAddress.length - 4
                                  )}`
                                : "-"}
                            </Index.Tooltip>
                            {row?.walletAddress && (
                              <Index.Box style={{ cursor: "pointer" }}>
                                <ContentCopyIcon
                                  fontSize="small"
                                  onClick={() =>
                                    copyToClipboard(row?.walletAddress)
                                  }
                                />
                              </Index.Box>
                            )}
                          </Index.Box>
                        </Index.TableCell>

                        {/* <Index.TableCell>
                          <Index.Box className="wallet-address">
                            <Index.Tooltip
                              title={row?.receiverAddress}
                              placement="top"
                            >
                              {row?.receiverAddress
                                ? `${row?.receiverAddress.substring(
                                    0,
                                    4
                                  )}.....${row?.receiverAddress.substring(
                                    row?.receiverAddress.length - 4
                                  )}`
                                : "-"}
                            </Index.Tooltip>
                            {row?.receiverAddress && (
                              <Index.Box style={{ cursor: "pointer" }}>
                                <ContentCopyIcon
                                  fontSize="small"
                                  onClick={() =>
                                    copyToClipboard(row?.receiverAddress)
                                  }
                                />
                              </Index.Box>
                            )}
                          </Index.Box>
                        </Index.TableCell> */}

                        <Index.TableCell>
                          <Index.Box className="wallet-address">
                            <Index.Tooltip
                              title={row?.sapTransactionHash}
                              placement="top"
                            >
                              {row?.sapTransactionHash
                                ? `${row?.sapTransactionHash.substring(
                                    0,
                                    4
                                  )}.....${row?.sapTransactionHash.substring(
                                    row?.sapTransactionHash.length - 4
                                  )}`
                                : "-"}
                            </Index.Tooltip>
                            {row?.sapTransactionHash && (
                              <Index.Box style={{ cursor: "pointer" }}>
                                <ContentCopyIcon
                                  fontSize="small"
                                  onClick={() =>
                                    copyToClipboard(row?.sapTransactionHash)
                                  }
                                />
                              </Index.Box>
                            )}
                          </Index.Box>
                        </Index.TableCell>
                        <Index.TableCell>
                          <Index.Box className="wallet-address">
                            <Index.Tooltip
                              title={row?.maticTransactionHash}
                              placement="top"
                            >
                              {row?.maticTransactionHash
                                ? `${row?.maticTransactionHash.substring(
                                    0,
                                    4
                                  )}.....${row?.maticTransactionHash.substring(
                                    row?.maticTransactionHash.length - 4
                                  )}`
                                : "-"}
                            </Index.Tooltip>
                            {row?.maticTransactionHash && (
                              <Index.Box style={{ cursor: "pointer" }}>
                                <ContentCopyIcon
                                  fontSize="small"
                                  onClick={() =>
                                    copyToClipboard(
                                      row?.maticTransactionHash
                                    )
                                  }
                                />
                              </Index.Box>
                            )}
                          </Index.Box>
                        </Index.TableCell>
                        <Index.TableCell>
                          {row?.sapTokenTransferStatus || "-"}
                        </Index.TableCell>
                        <Index.TableCell>
                          {row?.maticTokenTransferStatus || "-"}
                        </Index.TableCell>
                        <Index.TableCell>
                          {moment(row?.createdAt).format("DD/MM/YYYY  hh:mm A")}
                        </Index.TableCell>
                        {((row?.sapTokenTransferStatus !== "Success") || (row?.maticTokenTransferStatus !== "Success")) ? (
                          <Index.TableCell>
                            <button
                              className="transfer-btn"
                              onClick={() =>
                                handleTransferToken(row?._id, index)
                              }
                              disabled={btnLoading[index]}
                            >
                              {btnLoading[index] ? (
                                <CircularProgress size={12} color="inherit" />
                              ) : (
                                "Transfer"
                              )}
                            </button>
                          </Index.TableCell>
                        ) : (
                          <Index.TableCell> - </Index.TableCell>
                        )}
                      </Index.TableRow>
                    ))
                  ) : (
                    <PagesIndex.NoRecordFound colSpan={12} />
                  )
                ) : (
                  <PagesIndex.PageLoading colSpan={12} />
                )}
              </Index.TableBody>
            </Index.Table>
          </Index.TableContainer>
        </Index.Box>

        <Index.Box className="pagination-design flex-end">
          <Index.Stack spacing={2}>
            <PagesIndex.Pagination
              fetchData={filterData}
              setPageData={setPageData}
              pageData={pageData}
            />
          </Index.Stack>
        </Index.Box>
      </Index.Box>
    </Index.Box>
  );
};

export default AppTransactionList;
